import { create } from 'zustand';
import { INITIAL_CONFIGURATOR_STATE } from '../constants/configurator.constants';
import { ConfiguratorApi } from '../types/configurator.types';

export const useConfigurator = create<ConfiguratorApi>((set, get) => ({
	state: INITIAL_CONFIGURATOR_STATE,

	addSections: (count) => {
		const {
			state: { sections },
		} = get();
		const lastSection = sections[sections.length - 1];
		const newSections = Array.from({ length: count }).map(() => ({
			...lastSection,
		}));

		set({
			state: {
				...get().state,
				sections: [...sections, ...newSections],
			},
		});
	},
	removeSection: (index) => {
		const {
			state: { sections },
		} = get();
		const newSections = sections.filter((_, sectionIndex) => sectionIndex !== index);

		set({
			state: {
				...get().state,
				sections: newSections,
			},
		});
	},
	updateSections: (sectionIndexes, section) => {
		const sectionIndexesArray = Array.isArray(sectionIndexes)
			? sectionIndexes
			: [sectionIndexes];

		const {
			state: { sections },
		} = get();
		const newSections = sections.map((sectionItem, index) => {
			if (sectionIndexesArray.includes(index)) {
				return {
					...sectionItem,
					...section,
				};
			}

			return sectionItem;
		});

		set({
			state: {
				...get().state,
				sections: newSections,
			},
		});
	},
	updateOptions: (options) => {
		set({
			state: {
				...get().state,
				...options,
			},
		});
	},
	clear: () => set({ state: INITIAL_CONFIGURATOR_STATE }),
}));
